<script>
import dateMixin from '@/mixins/dateMixin';

/**
 * Dashboard Component
 */
export default {
  props: {
    orderItem: Object,
  },
  mixins: [dateMixin],
  methods: {
    removeWorkOrderItem(woItemIdPublic) {
      this.$emit('remove-work-order-item', this.orderItem, woItemIdPublic);
    },
  },
};
</script>

<template>
  <b-collapse
    v-if="orderItem.workOrderItemsSum > 0"
    :id="'collapse-' + orderItem.itemIdPublic"
    class="mt-2"
  >
    <div class="card-custom">
      <b-row class="table-header">
        <b-col class="flex-vertical-align" cols="3">
          {{ $t('workOrders.workOrderName') }}
        </b-col>
        <b-col class="text-center flex-vertical-align" cols="3">
          {{ $t('general.deliveryDate') }}
        </b-col>
        <b-col class="text-center flex-vertical-align" cols="3">
          {{ $t('items.quantity') }}
        </b-col>
        <b-col class="text-center flex-vertical-align" cols="3">
          {{ $t('general.delete') }}
        </b-col>
      </b-row>
      <b-row
        v-for="woItem in orderItem.workOrderItems"
        :key="woItem.idPublic"
        class="table-row"
      >
        <b-col class="flex-vertical-align" cols="3">{{
          woItem.workOrderName
        }}</b-col>
        <b-col class="text-center flex-vertical-align" cols="3">{{
          formatDate(woItem.workOrderDeliveryDate)
        }}</b-col>
        <b-col class="text-center flex-vertical-align" cols="3">{{
          woItem.requestedQuantity
        }}</b-col>
        <b-col class="text-center flex-vertical-align" cols="3">
          <i
            class="fas fa-trash-alt text-danger pl-2 pr-2"
            @click="removeWorkOrderItem(woItem.idPublic)"
            style="cursor: pointer; font-size: 1.3em"
          ></i>
        </b-col>
      </b-row>
    </div>
  </b-collapse>
</template>

<style scoped>
.card-custom {
  border: 1px solid #eee;
  padding: 0 30px 20px 30px;
  border-radius: 5px;
  background-color: #2a3042;
  color: #a6b0cf;
}
.table-header {
  font-weight: bold;
  border-bottom: 1px solid #a6b0cf;
  padding: 10px 0 10px 0;
  margin-top: 10px;
}
.table-row {
  padding: 10px 0 10px 0;
}
</style>